<template>
  <lm-icon-button
    class="LmReplyButton"
    icon="reply"
    label="Reply"
    @click.prevent="onReply"
  />
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'

export default {
  name: 'LmReplyButton',
  components: {LmIconButton},
  props: {
    authorId: {
      type: String,
      required: true
    }
  },
  methods: {
    onReply() {
      EventHub.emit(Events.REPLY_COMMENT, this.authorId)
    }
  }
}
</script>

<style scoped>
.LmReplyButton {
  color: theme('colors.gray.500');
  font-size: 12px;
  text-transform: uppercase;
}
</style>
<style>
.js-focus-visible .LmReplyButton:focus:not(.focus-visible) {
  outline: none;
}
</style>
